import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0 chat-wrapper chat-card h-100" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "title pb-15" }
const _hoisted_4 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "d-block text-black fs-md-15 fs-lg-16 fw-medium"
}
const _hoisted_6 = { class: "text-muted fw-normal fs-12" }
const _hoisted_7 = {
  class: "chat-list flex-grow-1",
  id: "chat-list-wrapper"
}
const _hoisted_8 = { class: "chat-item info text-center position-relative ps-0" }
const _hoisted_9 = { class: "d-inline-block fs-12 text-muted bg-white ps-12 pe-12 lh-1" }
const _hoisted_10 = { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium mb-10" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "message d-flex gap-2" }
const _hoisted_13 = { class: "inner" }
const _hoisted_14 = { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium mb-1" }
const _hoisted_15 = { class: "fs-md-15 fs-lg-16 lh-base" }
const _hoisted_16 = { class: "side d-flex flex-column justify-content-between align-items-start py-1" }
const _hoisted_17 = { class: "dropdown d-inline-flex justify-content-center align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1 /* HOISTED */)
const _hoisted_19 = { class: "dropdown-menu" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_22 = { class: "d-flex gap-1" }
const _hoisted_23 = { class: "fs-10 text-muted fw-normal lh-sm" }
const _hoisted_24 = {
  key: 0,
  class: "ph ph-checks text-info"
}
const _hoisted_25 = {
  key: 1,
  class: "write-your-message position-relative d-flex pe-0 gap-3 align-items-end"
}
const _hoisted_26 = { class: "d-flex flex-column flex-grow-1 gap-2" }
const _hoisted_27 = { class: "write-message position-relative flex-grow-1 p-0" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = {
  key: 0,
  class: "form-messages px-1"
}
const _hoisted_30 = { class: "write-message position-relative flex-grow-1 p-0" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = {
  key: 1,
  class: "form-messages px-1"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "buttons-list mt-0" }, [
  /*#__PURE__*/_createCommentVNode(" <button type=\"button\" class=\"border-0 d-inline-block position-relative text-center transition\">\n                            <i class=\"ph ph-image\"></i>\n                        </button>\n                        <button type=\"button\" class=\"border-0 d-inline-block position-relative text-center transition\">\n                            <i class=\"ph ph-link\"></i>\n                        </button> "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "border-0 d-inline-block position-relative text-center transition active"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-paper-plane-tilt" })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, [
            (_ctx.show_patient_name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  (_ctx.patient != undefined)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.patient.firstname) + " " + _toDisplayString(_ctx.patient.lastname), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" ... ")
                      ], 64 /* STABLE_FRAGMENT */))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('feature.messages')) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.total_messages
                            !==
                            0 ? `[${_ctx.total_messages}]` : ''), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
          ])
        ]),
        _createCommentVNode(" BODY "),
        _createElementVNode("div", _hoisted_7, [
          _createCommentVNode(" MESSAGE "),
          (_ctx.messages === undefined)
            ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                key: 0,
                class: "pt-50"
              }))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message_groups, (message_group, date) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: date }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(date), 1 /* TEXT */)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message_group, (messages, from_id) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: from_id }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages, (message, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["chat-item position-relative ps-0", { 'mb-0': index != messages.length - 1 }]),
                      key: message.id
                    }, [
                      _createElementVNode("span", _hoisted_10, [
                        (index == 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(message.from_firstname) + " " + _toDisplayString(message.from_lastname), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createCommentVNode(" MESSAGE "),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(message.subject), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_15, _toDisplayString(message.body), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("ul", _hoisted_19, [
                              _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                  class: "dropdown-item d-flex align-items-center",
                                  onClick: ($event: any) => (_ctx.confirmDeleteMessage(message))
                                }, [
                                  _hoisted_21,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.delete')), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_20)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.date_utils.HHmm(message.posted_at)), 1 /* TEXT */),
                            (message.read_at != null)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ])
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */)),
              _createCommentVNode("  ")
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          (_ctx.loading === true)
            ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                key: 0,
                class: "mt-25 align-items-center"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message_subject) = $event)),
                      type: "text",
                      class: "input-message d-block w-100 h-100 text-black fs-14 border-0 p-15",
                      placeholder: _ctx.$t('form.subject.placeholder')
                    }, null, 8 /* PROPS */, _hoisted_28), [
                      [_vModelText, _ctx.message_subject]
                    ])
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.subject ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.subject, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message_body) = $event)),
                      type: "text",
                      class: "input-message d-block w-100 min-h-75 text-black fs-14 border-0 p-15",
                      placeholder: _ctx.$t('form.message.placeholder'),
                      cols: "5"
                    }, null, 8 /* PROPS */, _hoisted_31), [
                      [_vModelText, _ctx.message_body]
                    ])
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.body ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.body, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _hoisted_33
              ]))
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteMessage())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}